import { keepPreviousData } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';

import { schemaGetConsorsNotesByLeadId } from '../schemas/getConsorsNotesByLeadId.schema';
import useLead from '~/features/leadDetails/hooks/useLead';
import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys';

export const useGetConsorsNotesByLeadId = (id: string) => {
    const queryKey = queryKeys.getConsorsNotesByLeadId(id);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);
    const { useParams } = getRouteApi('/_app/leads_/details/$leadId');
    const { leadId } = useParams();
    const { data: lead } = useLead(leadId);
    const subscriptionIdentifier = lead?.consors?.subscriptionIdentifier;

    return useAggregateQuery({
        acl: { loanRequestId: id },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getConsorsNotesByLeadId,
        schema: schemaGetConsorsNotesByLeadId,
        searchParams: { id, position: queryPosition, subscriptionIdentifier },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
